import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ py: 10, textAlign: 'center' }}>
      <Typography variant="h1">404</Typography>
      <Typography color="text.secondary">This page doesn't exist.</Typography>
      <Button variant="contained" onClick={() => navigate(ROUTES.dashboard)}>
        Back to Dashboard
      </Button>
    </Stack>
  );
}
